import Types from '../../action/types';
import Cookies from 'js-cookie';

const defaultState = {
  profileObj: null,
  historyObj: [],
  subscription: null,
  authorization: Cookies.get('authorization'),
  toolsModal: { open: false, fromSource: '' }, //肯定要埋点，这里判定一下购买的那个产品
  openLeave: { open: false },
  allSubscription: null,
  openPack: { open: false, type: '' },
};

export default function onAction(state = defaultState, action) {
  switch (action.type) {
    case Types.PROFILEOBJ:
      return {
        ...state,
        profileObj: action.profileObj,
      };
    case Types.HISTORYOBJ:
      return {
        ...state,
        historyObj: action.historyObj,
      };
    case Types.SUBSCRIPTION:
      return {
        ...state,
        subscription: action.subscription,
      };
    case Types.AUTHORIZATION:
      return {
        ...state,
        authorization: action.authorization,
      };
    case Types.OPENTOOLSMODAL:
      return {
        ...state,
        toolsModal: action.toolsModal,
      };
    case Types.OPENLEAVE:
      return {
        ...state,
        openLeave: action.openLeave,
      };
    case Types.ALLSUBSCRIPTION:
      return {
        ...state,
        allSubscription: action.allSubscription,
      };
    case Types.OPENPACK:
      return {
        ...state,
        openPack: action.openPack,
      };
    default:
      return state;
  }
}
